import { render, staticRenderFns } from "./MobileJobPage.vue?vue&type=template&id=128b80c6&scoped=true&"
import script from "./MobileJobPage.vue?vue&type=script&lang=js&"
export * from "./MobileJobPage.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./MobileJobPage.vue?vue&type=style&index=0&id=128b80c6&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "128b80c6",
  null
  ,true
)

export default component.exports